import { useContext } from 'react'
import { RegionContext } from '@/contexts/RegionContext'

/**
 * Hook para acceder a la información de región del usuario
 * 
 * @returns {object} Datos de región:
 *   - region: 'MX' | 'US'
 *   - currency: 'MXN' | 'USD'
 *   - country: Nombre del país detectado
 *   - isLoading: true mientras detecta
 *   - error: mensaje de error si falló
 *   - setRegion: función para cambiar región manualmente
 * 
 * @example
 * const { region, currency, isLoading } = useRegion()
 * 
 * if (isLoading) return <Spinner />
 * 
 * const planId = `basico_${region.toLowerCase()}` // 'basico_mx' o 'basico_us'
 */
export const useRegion = () => {
  const context = useContext(RegionContext)
  
  if (!context) {
    throw new Error('useRegion must be used within a RegionProvider')
  }
  
  return context
}

export default useRegion
